import { StatusBadge } from '../StatusBadge';
import { poStatusDisplay, type PoStatusKind } from './poStatus';

interface PoStatusBadgeProps {
    kind: PoStatusKind;
    value: string | null | undefined;
}

// Every purchase-order status renders through here, so an unmapped value is
// handled identically everywhere instead of per call site.
export function PoStatusBadge({ kind, value }: PoStatusBadgeProps) {
    const display = poStatusDisplay(kind, value);
    return <StatusBadge status={value ?? ''} toneOverride={display.tones} label={display.label} />;
}
